import React, { useEffect, useState } from "react";
import GroupedBarChart from "../../../../CHARTS/GroupedBarChart";

const MonthWiseGraph = ({ data, activeMetrics }) => {
  const [chartData, setChartData] = useState(null);
  function transformData(data, productName) {
    const result = {
      dimensions: ["product"],
      series: [],
    };

    // Add financial years to dimensions
    let years = [];
    data.forEach((fy) => {
      years.push(fy.financial_year);
    });

    years.sort((a, b) => Number(a.slice(0, 4)) - Number(b.slice(0, 4)));
    if (years.length > 0) {
      years.forEach((year) => {
        result.dimensions.push(year);
      });
    }
    // Get all unique months
    const months = new Set();
    data.forEach((fy) => {
      fy.children.forEach((month) => {
        months.add(month.monthName);
      });
    });

    // Transform data for each month
    months.forEach((month) => {
      const seriesItem = { product: month };

      data.forEach((fy) => {
        const monthData = fy.children.find((m) => m.monthName === month);
        let value = 0;

        if (monthData && monthData.data[0]) {
          const ireKey = `${productName}_IRE_tot`;
          const yDayKey = `${productName}_Y_DAY_O_B_tot`;
          const ire = parseFloat(monthData.data[0][ireKey]) || 0;
          const yDay = parseFloat(monthData.data[0][yDayKey]) || 0;
          value = yDay !== 0 ? ((ire / yDay) * 100).toFixed(2) : 0;
        }

        seriesItem[fy.financial_year] = value;
      });

      result.series.push(seriesItem);
    });

    return result;
  }

  // Example usage:
  useEffect(() => {
    if (data) {
      const transformed = transformData(data, activeMetrics);
      setChartData(transformed);
    }
  }, [data]);

  return (
    <div style={{ zIndex: 1 }}>
      <h5 className="bg-dark text-white"> IRE Summary</h5>
      {!data ? (
        <b style={{ color: "red", fontSize: "14px" }}>Data not found!</b>
      ) : null}
      {chartData && (
        <GroupedBarChart
          height={320}
          data={chartData}
          from="IRE" //for same graph design as the PDD_C
          chartType="bar"
        />
      )}
    </div>
  );
};

export default MonthWiseGraph;
